<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Cambiar Clave</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formulario" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Clave </mat-label>
                <input
                    matInput
                    type="password"
                    name="clave1"
                    formControlName="clave1"
                    required
                />
                <mat-error *ngIf="clave1.hasError('invalidPassword')">
                    La clave debe tener al menos 1 mayuscula y 1 numero y un
                    caracter especial
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Repita la Clave </mat-label>
                <input
                    matInput
                    type="password"
                    name="clave2"
                    formControlName="clave2"
                    required
                />
                <mat-error *ngIf="clave2.hasError('passwordMismatch')">
                    Las claves no coinciden
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formulario.value"
            [disabled]="!formulario.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
